module.exports = __webpack_public_path__ + "img/dv.12479beb.png";